// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Richtext_buttonContainer__rZjFW"};